import { createReducer } from '@/utils/redux/reducer-util';
import { AuthState, initialState } from './types';

export const reducers = createReducer<AuthState>(initialState, {

});

export default reducers;
